<!-- 查询结果 -->
<template>
    <div v-if="componentsData.type == 17">
        <div
            class="overflow-hidden bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <template v-if="componentsData.content.title">
                <div
                    class="fw-bold flex-c"
                    v-if="componentsData.content.style_value == 1"
                    :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};
                        background: ${componentsData.content.title_bg_color}; color: ${componentsData.content.title_color}; font-size: ${componentsData.content.title_size}px;
                    `"
                >
                    <div
                        class="dec-left"
                        :style="{ background: decLeft }"
                    ></div>
                    <div class="dec-content">
                        {{ componentsData.content.title }}
                    </div>
                    <div
                        class="dec-right"
                        :style="{ background: decRight }"
                    ></div>
                </div>
                <div
                    v-else
                    class="fw-bold"
                    :style="`text-align: ${componentsData.content.position};border-bottom: 1px solid ${componentsData.content.title_border_color};
                        background: ${componentsData.content.title_bg_color}; color: ${componentsData.content.title_color}; font-size: ${componentsData.content.title_size}px;
                    `"
                >
                    {{ componentsData.content.title }}
                </div>
            </template>
            <div
                class="pt-6"
                :style="` color: ${componentsData.content.text_color}; font-size: ${componentsData.content.text_size}px; `"
            >
                多次查询，请确保是您本人查询，防伪编码:xxx，您査询的是本公司正品，本次为第x次查询，首次查询时间：xxxx-xx-xx
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
    padding-bottom: 6px;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.pt-6 {
    padding-top: 6px;
}
</style>